import { ArrowDown, ArrowUp, ExternalLink, Mail } from "lucide-react";

const STATUS_LABELS = {
  preparation: { label: "Analyse IA…", cls: "col-green" },
  pret: { label: "Prêt à envoyer", cls: "col-green" },
  a_traiter: { label: "À traiter", cls: "col-orange" },
  envoye: { label: "Envoyé", cls: "col-purple" },
  termine: { label: "Terminé", cls: "col-gray" },
};

function fullDate(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export const InboxListView = ({ tickets, selectedIds, onToggle, onToggleAll, sortDir, onToggleSort, gmailUrl, columns, onMove }) => {
  const allSelected = tickets.length > 0 && tickets.every((ticket) => selectedIds.includes(ticket.id));
  return (
    <div className="table-wrap inbox-list" data-testid="inbox-list-view">
      <table data-testid="inbox-list-table">
        <thead>
          <tr>
            <th className="select-cell">
              <input type="checkbox" aria-label="Tout sélectionner" checked={allSelected} onChange={() => onToggleAll(tickets)} data-testid="inbox-list-select-all" />
            </th>
            <th>Commune</th>
            <th>Expéditeur</th>
            <th>
              <button type="button" className="sort-button" onClick={onToggleSort} data-testid="inbox-list-sort-date">
                Reçu le {sortDir === "desc" ? <ArrowDown size={13} /> : <ArrowUp size={13} />}
              </button>
            </th>
            <th>Résumé IA</th>
            <th>Statut</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {tickets.length === 0 && <tr><td colSpan="7" className="empty-cell" data-testid="inbox-list-empty">Aucun ticket sur cette période.</td></tr>}
          {tickets.map((ticket) => {
            const status = STATUS_LABELS[ticket.status] || { label: ticket.status, cls: "col-gray" };
            return (
              <tr key={ticket.id} className={selectedIds.includes(ticket.id) ? "row-selected" : ""} data-testid={`inbox-list-row-${ticket.id}`}>
                <td className="select-cell">
                  <input type="checkbox" aria-label="Sélectionner ce ticket" checked={selectedIds.includes(ticket.id)} onChange={() => onToggle(ticket.id)} data-testid={`inbox-list-select-${ticket.id}`} />
                </td>
                <td>
                  {ticket.lead_url ? (
                    <a href={ticket.lead_url} target="_blank" rel="noreferrer" className="lead-link">{ticket.commune_name || "—"} <ExternalLink size={11} /></a>
                  ) : (ticket.commune_name || "—")}
                  {ticket.is_refusal && <span className="list-tag refusal">Refus</span>}
                </td>
                <td className="mono list-from">{ticket.from_email}{ticket.account_email && <div className="gmail-box-chip">→ {ticket.account_email}</div>}</td>
                <td className="mono" data-testid={`inbox-list-date-${ticket.id}`}>{fullDate(ticket.received_at)}</td>
                <td className="list-summary" title={ticket.ai_summary || ""}>{ticket.ai_summary || <span className="muted">—</span>}</td>
                <td>
                  <select
                    className={`status-select ${status.cls}`}
                    value={ticket.status === "preparation" ? "pret" : ticket.status}
                    onChange={(event) => onMove(ticket.id, event.target.value)}
                    aria-label="Changer le statut"
                    data-testid={`inbox-list-status-${ticket.id}`}
                  >
                    {columns.map((column) => <option key={column.key} value={column.key}>{column.title}</option>)}
                  </select>
                </td>
                <td className="list-actions">
                  {(ticket.thread_id || ticket.gmail_message_id) && (
                    <a className="gmail-link" href={gmailUrl(ticket.thread_id || ticket.gmail_message_id, ticket.account_email || undefined)} target="_blank" rel="noreferrer" title="Ouvrir dans Gmail" data-testid={`inbox-list-gmail-${ticket.id}`}>
                      <Mail size={14} />
                    </a>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
